import * as api from '@/modules/sso-join-rules/api'
import { computed, reactive, ref } from 'vue'
import * as types from './types'
import { SimpleListFilterParameters } from '@/views/_shared/search-list/types'
export * from './types'

const ssoJoinRules = ref<api.GetSSOJoinRulesListResponse['results']>([])
const ssoJoinRulesCount = ref(0)
const currentSSOJoinRule = ref<types.SSOJoinRulesListModel>()

const defaultSortBy = 'id desc'

export const ssoJoinRulesFilter = reactive<SimpleListFilterParameters>({
    search: '',
    sortBy: null,
    limit: 10,
    offset: 0
})

const getSSOJoinRules = () =>
    api.getSSOJoinRules(
        ssoJoinRulesFilter.search,
        ssoJoinRulesFilter.sortBy || defaultSortBy,
        ssoJoinRulesFilter.limit,
        ssoJoinRulesFilter.offset
    ).then(
        ssoJoinRulesList => {
            ssoJoinRulesCount.value = ssoJoinRulesList.count
            ssoJoinRules.value = ssoJoinRulesList.results
        }
    )

const getSSOJoinRule = async (joinRuleId: string) =>
    api.getSSOJoinRule(joinRuleId).then(
        joinRule => {
            currentSSOJoinRule.value = joinRule
        }
    )

const addSSOJoinRule = (payload: api.AddSSOJoinRuleRequest) => api.addSSOJoinRule(payload).then(getSSOJoinRules)

const deleteSSOJoinRule = (id: string) => api.deleteSSOJoinRule(id).then(getSSOJoinRules)

export function useSSOJoinRulesModule () {
    return {
        getSSOJoinRules,
        ssoJoinRules: computed(() => ssoJoinRules.value),
        ssoJoinRulesCount: computed(() => ssoJoinRulesCount.value),
        ssoJoinRulesFilter,
        getSSOJoinRule,
        currentSSOJoinRule: computed(() => currentSSOJoinRule.value),
        addSSOJoinRule,
        updateSSOJoinRule: api.updateSSOJoinRule,
        deleteSSOJoinRule
    }
}
